import React from 'react';
import { Award, Download, Send, Eye } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
export function EventsCertificates() {
  const certificates = [{
    id: 1,
    event: 'React Workshop',
    attendee: 'Ahmad Rizki',
    issued: 'Jan 17, 2025',
    status: 'Sent'
  }, {
    id: 2,
    event: 'React Workshop',
    attendee: 'Siti Rahayu',
    issued: 'Jan 17, 2025',
    status: 'Sent'
  }, {
    id: 3,
    event: 'AI & ML Seminar',
    attendee: 'Budi Hartono',
    issued: 'Jan 21, 2025',
    status: 'Ready'
  }];
  return <div className="min-h-screen bg-white" data-id="element-2772">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-2773">
        <div className="flex items-center justify-between mb-8" data-id="element-2774">
          <div data-id="element-2775">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-2776">
              Certificates
            </h1>
            <p className="text-neutral-600" data-id="element-2777">
              Generate and manage event certificates
            </p>
          </div>
          <Button data-id="element-2778">
            <Award className="w-4 h-4 mr-2" data-id="element-2779" />
            Generate Certificates
          </Button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-2780">
          {[{
          label: 'Total Issued',
          value: '234'
        }, {
          label: 'Pending',
          value: '12'
        }, {
          label: 'This Month',
          value: '45'
        }].map((stat, i) => <Card key={i} data-id="element-2781">
              <CardContent className="p-6" data-id="element-2782">
                <div className="flex items-center gap-4" data-id="element-2783">
                  <div className="p-3 rounded-lg bg-atios-light" data-id="element-2784">
                    <Award className="w-6 h-6 text-atios-primary" data-id="element-2785" />
                  </div>
                  <div data-id="element-2786">
                    <h3 className="text-2xl font-semibold text-neutral-900" data-id="element-2787">
                      {stat.value}
                    </h3>
                    <p className="text-sm text-neutral-600" data-id="element-2788">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <Card data-id="element-2789">
          <CardHeader data-id="element-2790">
            <CardTitle data-id="element-2791">Recent Certificates</CardTitle>
          </CardHeader>
          <CardContent data-id="element-2792">
            <div className="space-y-4" data-id="element-2793">
              {certificates.map(cert => <div key={cert.id} className="flex items-center justify-between p-4 border border-neutral-200 rounded-lg hover:border-atios-primary transition-colors" data-id="element-2794">
                  <div className="flex items-center gap-4" data-id="element-2795">
                    <div className="p-3 rounded-lg bg-atios-light" data-id="element-2796">
                      <Award className="w-5 h-5 text-atios-primary" data-id="element-2797" />
                    </div>
                    <div data-id="element-2798">
                      <h4 className="font-medium text-neutral-900" data-id="element-2799">
                        {cert.event}
                      </h4>
                      <p className="text-sm text-neutral-600" data-id="element-2800">
                        {cert.attendee} • Issued {cert.issued}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3" data-id="element-2801">
                    <Badge variant={cert.status === 'Sent' ? 'success' : 'default'} data-id="element-2802">
                      {cert.status}
                    </Badge>
                    <div className="flex gap-2" data-id="element-2803">
                      <Button size="sm" variant="secondary" data-id="element-2804">
                        <Eye className="w-4 h-4 mr-2" data-id="element-2805" />
                        Preview
                      </Button>
                      <Button size="sm" variant="secondary" data-id="element-2806">
                        <Download className="w-4 h-4 mr-2" data-id="element-2807" />
                        Download
                      </Button>
                      {cert.status === 'Ready' && <Button size="sm" data-id="element-2808">
                          <Send className="w-4 h-4 mr-2" data-id="element-2809" />
                          Send
                        </Button>}
                    </div>
                  </div>
                </div>)}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}